/* eslint-disable no-useless-computed-key */
let initialState = {
  selectCategoryValue: null,
  selectBrandValue: {
    global_dashboard: { data: null },
    dashboard_section: { data: null },
    dashboard_widget: { data: null },
    template_global: { data: null },
    template_section: { data: null },
    template_widget: { data: null },
    graph_page: { data: null },
    orm_dashboard: { data: null },
    share_modal: { data: null },
    widgetMaker: { data: null },
    preview: { data: null },
    share_dashboard_global: { data: null },
  },
  brandCheckedItems: {
    global_dashboard: { data: { ["All"]: true } },
    dashboard_section: { data: { ["All"]: true } },
    dashboard_widget: { data: { ["All"]: true } },
    template_global: { data: { ["All"]: true } },
    template_section: { data: { ["All"]: true } },
    template_widget: { data: { ["All"]: true } },
    graph_page: { data: { ["All"]: true } },
    orm_dashboard: { data: { ["All"]: true } },
    share_modal: { data: { ["All"]: true } },
    widgetMaker: { data: { ["All"]: true } },
    preview: { data: { ["All"]: true } },
    share_dashboard_global: { data: { ["All"]: true } },
  },
  categoryCheckedItems: { ["All"]: true },
  categoryFlag: false,
  brandFlag: false,
  brandActiveKey: null,
  categoryActiveKey: null,
  openPre: false,
  openDuring: false,
  openPost: false,
  dashboardBrandObj: null,
  templateBrandObj: null,
  profileId: null,
  channelImage: null,
  profileImage: null,
  clearBrandAndDuration: {
    sectionLevelBrand: false,
    widgetLevelBrand: false,
    sectionLevelDuration: false,
    widgetLevelDuration: false,
  },
  dashboardProfileFilterObj: null,
  competitorBrandType: "initial",
};
const Template = (state = initialState, action) => {
  switch (action.type) {
    case "SET_CATEGORY_VALUE":
      return {
        ...state,
        selectCategoryValue: action.payload,
      };
    case "SET_BRAND_VALUE":
      return {
        ...state,
        selectBrandValue: action.payload,
      };

    case "SET_PROFILE_ID":
      return {
        ...state,
        profileId: action.payload,
      };
    case "SET_CHANNEL_IMAGE":
      return {
        ...state,
        channelImage: action.payload,
      };
    case "SET_PROFILE_IMAGE":
      return {
        ...state,
        profileImage: action.payload,
      };
    case "SET_BRAND_CHECKED_ITEMS":
      return {
        ...state,
        brandCheckedItems: action.payload,
      };
    case "SET_CATEGORY_CHECKED_ITEMS":
      return {
        ...state,
        categoryCheckedItems: action.payload,
      };
    case "SET_CATEGORY_FLAG":
      return {
        ...state,
        categoryFlag: action.payload,
      };
    case "SET_BRAND_FLAG":
      return {
        ...state,
        brandFlag: action.payload,
      };
    case "SET_BRAND_ACTIVE_KEY":
      return {
        ...state,
        brandActiveKey: action.payload,
      };
    case "SET_CATEGORY_ACTIVE_KEY":
      return {
        ...state,
        categoryActiveKey: action.payload,
      };
    case "SET_PRE_CRISIS_DATE":
      return {
        ...state,
        openPre: action.payload,
      };
    case "SET_DURING_CRISIS_DATE":
      return {
        ...state,
        openDuring: action.payload,
      };
    case "SET_POST_CRISIS_DATE":
      return {
        ...state,
        openPost: action.payload,
      };
    case "DASHBOARD_BRAND_FFILTER_OBJ":
      return {
        ...state,
        dashboardBrandObj: action.payload,
      };
    case "TEMPLATE_BRAND_FFILTER_OBJ":
      return {
        ...state,
        templateBrandObj: action.payload,
      };
    case "SET_CLEAR_BRAND_AND_DURATION":
      return {
        ...state,
        clearBrandAndDuration: action.payload,
      };
    case "DASHBOARD_PROFILE_FILTER_OBJ":
      return {
        ...state,
        dashboardProfileFilterObj: action.payload,
      };
    case "SET_COMPETITOR_BRAND_TYPE":
      return {
        ...state,
        competitorBrandType: action.payload,
      };

    default:
      return state;
  }
};

export default Template;
